import React, { useEffect, useRef } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { srConfig } from '@config';
import sr from '@utils/sr';
import { usePrefersReducedMotion } from '@hooks';

const StyledAboutSection = styled.section`
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;
const StyledText = styled.div`
  ul.skills-list {
    display: grid;
    grid-template-columns: repeat(2, minmax(140px, 200px));
    grid-gap: 0 10px;
    padding: 0;
    margin: 20px 0 0 0;
    overflow: hidden;
    list-style: none;

    li {
      position: relative;
      margin-bottom: 10px;
      padding-left: 20px;
      font-family: var(--font-mono);
      font-size: var(--fz-xs);

      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
        font-size: var(--fz-sm);
        line-height: 12px;
      }
    }
  }
`;
const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  .wrapper {
    ${({ theme }) => theme.mixins.boxShadow};
    display: block;
    position: relative;
    width: 100%;
    border-radius: var(--border-radius);
    background-color: var(--green);

    &:hover,
    &:focus {
      outline: 0;
      transform: translate(-4px, -4px);

      &:after {
        transform: translate(8px, 8px);
      }

      .img {
        filter: none;
        mix-blend-mode: normal;
      }
    }

    .img {
      position: relative;
      border-radius: var(--border-radius);
      mix-blend-mode: multiply;
      filter: grayscale(100%) contrast(1);
      transition: var(--transition);
    }

    &:before,
    &:after {
      content: '';
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: var(--border-radius);
      transition: var(--transition);
    }

    &:before {
      top: 0;
      left: 0;
      background-color: var(--navy);
      mix-blend-mode: screen;
    }

    &:after {
      border: 2px solid var(--green);
      top: 14px;
      left: 14px;
      z-index: -1;
    }
  }
`;

const About = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  const skills = ['JavaScript (ES6+)', 'TypeScript', 'React', 'Redux', 'Next.Js', 'Vue.Js', 'Fullstack', 'Eleventy', 'Node.js', 'WordPress', 'Shopify', 'Elastic Search', 'AWS', 'Kafka', 'Go', 'PHP'];

  return (
    <StyledAboutSection id="about" ref={revealContainer}>
      <h2 className="numbered-heading">About Me</h2>

      <div className="inner">
        <StyledText>
          <div>
            <p>Hello! My name is Amit here is my Profile Summary:</p>

            <p>
              Full-stack Developer with 8 years of expertise in React.js and 5
              years of experience in Node.js development. Adept at creating exceptional user
              interfaces and interactive web applications using React, Next.js, and Jest on the
              front-end, and Node.js, Express.js, and other relevant technologies on the back-end.
              Proven track record of delivering high-quality, scalable, and performant solutions by
              implementing efficient code architecture, unit testing, and test-driven development
              (TDD) practices.
            </p>

            <p>
              Experienced in collaborating with cross-functional teams to understand project
              requirements, design intuitive user experiences, and deliver innovative full-stack
              solutions within specified timelines. Possess a strong passion for staying updated
              with the latest front-end and back-end technologies, as well as best practices, to
              continuously enhance development processes and user satisfaction.
            </p>

            <p>
              Throughout my career, I have demonstrated the ability to work seamlessly across the
              entire development lifecycle, from initial concept to deployment and maintenance. As a
              results-driven full-stack developer, I thrive in dynamic environments and am committed
              to delivering top-notch digital experiences that exceed expectations.
            </p>

            <p>
              Seeking challenging opportunities to leverage my extensive experience in both React.js
              and Node.js development, I am eager to contribute to the success of cutting-edge web
              applications, ensuring they are robust, scalable, and provide a seamless user
              experience.
            </p>

            <p>Here are a few technologies I’ve been working with recently:</p>
          </div>

          <ul className="skills-list">
            {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
          </ul>
        </StyledText>

        <StyledPic>
          <div className="wrapper">
            <StaticImage
              className="img"
              src="../../images/me.jpg"
              width={500}
              quality={95}
              formats={['AUTO', 'WEBP', 'AVIF']}
              alt="Headshot"
            />
          </div>
        </StyledPic>
      </div>
    </StyledAboutSection>
  );
};

export default About;
